import './MarkupLayer.css'

const IconMarkup = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h16" />
    <path d="M6 16l8-8 4 4-8 8H6z" />
  </svg>
)

export function MarkupToggle({ on, onClick, disabled }) {
  return (
    <button
      type="button"
      className={'markup-toggle' + (on ? ' is-active' : '')}
      onClick={onClick}
      disabled={disabled}
      title={on ? 'Hide markups' : 'Show markups'}
      aria-label={on ? 'Hide markups' : 'Show markups'}
      aria-pressed={on}
    >
      <IconMarkup />
    </button>
  )
}
